import React from 'react';
import { ChatSession } from 'flow/types/Chats';
import { TypedMap } from 'flow/types/TypedMap';
import { translateNumber } from 'flow/utils/browser-utils';

interface Props {
    session: TypedMap<ChatSession>;
}

const UnreadBadge = ({ session }: Props) => {
    return session.get('numberOfUnreadMessages') ? (
        <div
            data-test-id={`unread-badge-${session.get('key')}`}
            className="bg-red text-2xs absolute -end-1 -top-1 flex size-5 items-center justify-center rounded-full font-bold text-white dark:text-black"
        >
            {translateNumber(session.get('numberOfUnreadMessages'))}
        </div>
    ) : null;
};

export default UnreadBadge;
